import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "botones" }
const _hoisted_6 = ["disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'MensajeConfirmacion',
  props: {
    visible: { type: Boolean },
    title: {},
    message: {},
    confirmText: {},
    cancelText: {},
    confirmLoading: { type: Boolean }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any) {

/**
 * Diálogo de confirmación para acciones destructivas.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */





return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          (_ctx.message)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.message), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.cancelText)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn cancelar",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
                }, _toDisplayString(_ctx.cancelText), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn guardar",
              disabled: _ctx.confirmLoading,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
            }, _toDisplayString(_ctx.confirmLoading ? 'Procesando...' : _ctx.confirmText), 9, _hoisted_6)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})